import { Action, createReducer, on } from '@ngrx/store';
import { ActionComponent, AddAction } from './component.actions';

export interface ComponentState {
	component: string
	action: string
	parameter: string[]
}

const initialState: ComponentState = { 
	component:'', 
	action: '',
	parameter: [] 
}

const _componentReducer = createReducer(initialState,
	on(ActionComponent, (state, props) => {
		return {
			...state,
			component: props.component,
			action: props.action,
			parameter: props.parameter
		};
	}),
	on(AddAction, (state, props) => {		
		return {
			...state,
			component: state.component,
			action: props.action,
			parameter: state.parameter
		};
	}),
);

export function ComponentReducer(state: ComponentState, action: Action) {	
	return _componentReducer(state, action);
}

export const getIsComponent = (state: ComponentState) => state.action;
